type WidgetConfig = {
  id: string;
  name: string;
}

export const qualifyFormReviewsWidgetConfig: WidgetConfig = {
  id: `d2513116-1d73-479e-91b9-a9a78c55e7ce`,
  name: `Qualify form review section`
}

export const homepageReviewsWidgetConfig: WidgetConfig = {
  id: `c56647c5-4398-446d-9e79-f6d54f2049ad`,
  name: `Homepage review section`
}